import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="Spielanleitung" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500">
        Finden Sie das CRODLE in 6 Versuchen. 
        Nach jedem Versuch ändert sich die Farbe der Kacheln, um anzuzeigen, wie nahe Ihr Wort an der Lösung war.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="V" status="correct" />
        <Cell value="E" />
        <Cell value="L" />
        <Cell value="I" />
        <Cell value="K" />
      </div>
      <p className="text-sm text-gray-500">
        Der Buchstabe V ist im Wort und an der richtigen Stelle.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="R" />
        <Cell value="I" />
        <Cell value="J" status="present" />
        <Cell value="E" />
        <Cell value="Č" />
      </div>
      <p className="text-sm text-gray-500">
        Der Buchstabe J ist im Wort, aber an einer anderen Stelle.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="Č" />
        <Cell value="E" />
        <Cell value="S" />
        <Cell value="T" status="absent" />
        <Cell value="O" />
      </div>
      <p className="text-sm text-gray-500">
        Der Buchstabe T ist nicht im gesuchten Wort enthalten.
      </p>
      <p className="text-sm text-gray-500">
        <br /><b>Wichtiger Hinweis:</b> <br />Der Einfachheit halber werden in diesem Spiel <b>NJ</b>, <b>LJ</b> und <b>DŽ</b> jeweils als zwei Buchstaben behandelt.
      </p>
    </BaseModal>
  )
}
